import { useState } from "react";
import Browser from "../browser";
import { itx } from "../translationItx/itx";
import { MobileInstallHint } from "./MobileInstallHint";
import { isAppleMobile } from "./pwaInstall";

type WarningScope = "main" | "registration" | "project-selection";

// Acknowledging one entry point must not hide the warning at another one.
const dismissedScopes = new Set<WarningScope>();

export default function FullSceenButton({ scope = "main" }: { scope?: WarningScope }) {
  const [visible, setVisible] = useState(true);
  const gentle = scope !== "main";

  if ((!Browser.isMobile() && !isAppleMobile()) || !visible || dismissedScopes.has(scope)) {
    return null;
  }

  return (
    <div
      id="mobile-device-warning"
      role={gentle ? "dialog" : "alertdialog"}
      aria-modal="true"
      aria-labelledby="mobile-device-warning-message"
      data-warning-level={gentle ? "notice" : "unsupported"}
      className={gentle ? "mobileDeviceNotice" : undefined}
      style={{
        position: "fixed",
        inset: 0,
        boxSizing: "border-box",
        padding: "40px 20px",
        backgroundColor: gentle ? "rgba(23, 35, 51, 0.35)" : "#fff",
        color: "#000",
        zIndex: 1000,
        overflowY: "auto",
        touchAction: "pan-y",
        display: gentle ? "flex" : "block",
        alignItems: gentle ? "safe center" : undefined,
        justifyContent: gentle ? "center" : undefined,
      }}
      onKeyDown={event => {
        if (event.key !== "Tab") return;
        const controls = [...event.currentTarget.querySelectorAll<HTMLButtonElement>('button:not([disabled])')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && event.target === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && event.target === last) { event.preventDefault(); first?.focus(); }
      }}
    >
      <div style={{ maxWidth: "600px", width: "100%", margin: "0 auto", boxSizing: "border-box",
        padding: gentle ? "24px" : undefined, borderRadius: gentle ? "12px" : undefined, backgroundColor: "#fff" }}>
        <p id="mobile-device-warning-message" style={{ whiteSpace: "pre-line", lineHeight: gentle ? undefined : 1.6 }}>
          {gentle ? itx(
            "mobileWarning.desktopText",
            "ESTADA lässt sich am besten am Desktop nutzen.\nFür den vollen Funktionsumfang empfehlen wir Chrome auf einem Desktop oder Laptop.",
          ) : itx(
            "mobileWarning.text",
            "Auf mobilen Geräten ist das Arbeiten mit Estada nicht möglich.\nBitte nutze den Browser auf Deinem Desktop.\nAm besten geeignet ist Chrome.",
          )}
        </p>
        {gentle && <hr className="mobileDeviceNoticeDivider" />}
        {gentle && <p className="mobileDeviceNoticeMobileText">{itx(
          "mobileWarning.mobileText",
          "Concept One kannst du auf mobilen Geräten mit ausgewählten Funktionen nutzen.\nAm besten mit eigenem App-Symbol auf Homescreen – mit mehr Platz für Deinen Plan.",
        )}</p>}
        {gentle && <MobileInstallHint />}
        <button
          id="mobile-device-warning-dismiss"
          type="button"
          className="btn button"
          autoFocus
          style={{
            backgroundColor: gentle ? "#e57e04" : "grey",
            color: "white",
            minHeight: "50px",
            borderRadius: "25px",
            width: "100%",
            maxWidth: "300px",
            marginTop: "20px",
          }}
          onClick={() => {
            dismissedScopes.add(scope);
            setVisible(false);
          }}
        >
          {gentle ? itx("mobileWarning.softButton", "Fortfahren") : itx("mobileWarning.button", "Ignorieren")}
        </button>
      </div>
    </div>
  );
}
